import SyncScheduleForm from '../Forms/SyncScheduleForm';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { actions } from '../../context';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
// TODO: push some of this state and logic down to the form component
const PracticeScheduleModal = () => {
    const dispatch = useDispatch();
    
    const { nextSyncDate, practiceId } = useSelector(
        (state) => {
            const { nextSyncDate, id } =
                state.practice.practiceSheduleModalWorkingPractice;
            return { nextSyncDate, practiceId: id };
        },
        shallowEqual
    );
    const [configData, setConfigData] = useState({});

    const isPracticeScheduleModalOpen = useSelector((state) => state.toggle.isPracticeScheduleModalOpen);

    useEffect(() => {
        if (practiceId)
            dispatch(
                actions.practice.getPracticeConfiguration(practiceId)
            ).then((res) => setConfigData(res));
        // eslint-disable-next-line
    }, [dispatch, isPracticeScheduleModalOpen]);

    return (
        <Modal
            style={{ minWidth: '45vw' }}
            className="text-light"
            isOpen={isPracticeScheduleModalOpen}
            centered={true}
            toggle={() =>
                dispatch(actions.toggle.togglePracticeScheduleModal())
            }>
            <ModalHeader>Practice Sync Schedule</ModalHeader>
            <ModalBody>
                <SyncScheduleForm
                    configuration={configData}
                    practiceId={practiceId}
                    nextSyncDate={nextSyncDate}
                    cancel={() =>
                        dispatch(actions.toggle.togglePracticeScheduleModal())
                    }
                />
            </ModalBody>
        </Modal>
    );
};

export default PracticeScheduleModal;
